import { Row } from '@devexpress/dx-react-grid';
import { MainPageContainer, UpperInfoContainer } from 'components/PageLayout';
import { useWPSiteConnectionsReport } from 'pages/hooks';
import { useMemo } from 'react';
import { AxiosError } from 'axios';
import { errorMessages } from 'api/resources/responseMessages/errorMessages';
import { ReportGridContainer } from 'components/ReportGridContainer';
import { NoReportDataMessage } from 'components/ReportsComponents/NoReportDataMessage';
import { ReportBackButton } from 'components/ReportsComponents/ReportBackButton';
import {
  WP_SITE_CONNECTION_REPORT_GRID_TITLE,
  WP_SITE_CONNECTIONS_REPORT_MESSAGE,
  WP_SITE_CONNECTION_REPORT,
  columns,
  reportHeaderTagLine,
  mockedReportData,
} from './constants';
import { ReportHeader } from 'components/ReportsComponents/ReportHeader';
import { ReportProps } from 'pages/ReportsDetails/hooks';
import { reportLogger } from 'pages/ReportsDetails/reportLogger';
import ReportGridNew from 'components/ReportGrid_New';

export function WPSiteConnectionsReport({
  setErrorMessage,
  setToast,
}: Readonly<ReportProps>) {
  const { isReportFetching, reportData } =
    useWPSiteConnectionsReport(handleError);

  const rows = useMemo<Row>(() => reportData, [reportData]);
  // const rows = mockedReportData;

  return (
    <MainPageContainer isLoading={isReportFetching} direction="column" wrap="nowrap">
      <UpperInfoContainer direction="column">
        <ReportBackButton />
        <ReportHeader
          reportName={WP_SITE_CONNECTION_REPORT}
          infoMessage={WP_SITE_CONNECTIONS_REPORT_MESSAGE}
        />
      </UpperInfoContainer>

      {!isReportFetching && rows?.length === 0 && <NoReportDataMessage />}

      <ReportGridContainer direction="column">
        <ReportGridNew
          columns={columns}
          displayGroupingPanel
          headerTitleForSheet={WP_SITE_CONNECTION_REPORT}
          isLoading={isReportFetching}
          pdfOrientation='l'
          reportHeaderTagLine={reportHeaderTagLine}
          rows={rows}
          title={WP_SITE_CONNECTION_REPORT_GRID_TITLE}
        />
      </ReportGridContainer>
    </MainPageContainer>
  );

  function handleError(error: AxiosError) {
    reportLogger(error);
    setErrorMessage(errorMessages.reports('WP site connections Report'));
    setToast(true);
  }
}
